import { CoachBotUiModule } from '@alpha-coach-bot/coach-bot/ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { DashboardNavigationComponent, DashboardProfileMenuComponent, DashboardTopBarComponent } from '../components';

const COMPONENTS = [DashboardNavigationComponent, DashboardProfileMenuComponent, DashboardTopBarComponent];

@NgModule({
  imports: [ButtonModule, CoachBotUiModule, CommonModule, ContextMenuModule, MatToolbarModule, TranslateModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class DashboardUiModule {}
